import { Component } from '@theme/component';

export class ProductPaidOptionComponent extends Component {
  requiredRefs = ['checkbox'];

  connectedCallback() {
    super.connectedCallback();
    const section = this.closest('.shopify-section') || document;
    this.productForm = section.querySelector('product-form-component');
  }

  handleChange() {
    const hiddenInput = this.querySelector('.product-paid-option__variant-id');
    if (!hiddenInput) return;
    
    if (this.refs.checkbox.checked) {
      hiddenInput.removeAttribute('disabled');
      // Set a data attribute on the form to let it know an addon is active
      if (this.productForm) {
        this.productForm.dataset.addonActive = 'true';
        this.productForm.dataset.addonVariantId = hiddenInput.value;
      }
    } else {
      hiddenInput.setAttribute('disabled', 'disabled');
      if (this.productForm) {
        this.productForm.dataset.addonActive = 'false';
        this.productForm.removeAttribute('data-addon-variant-id');
      }
    }
  }
}

if (!customElements.get('product-paid-option-component')) {
  customElements.define('product-paid-option-component', ProductPaidOptionComponent);
}
